/**
 * @typedef {Date|import('luxon').DateTime|number} TimeLike
 */

/**
 * @typedef {{time:Date,data:any}} TimelineDatum
 */

export default class TimelineDataset {
  _timeAttributePath;
  _range;
  constructor({
    range,
    timeAttributePath
  }) {
    this._timeAttributePath = timeAttributePath;
    this._range = range;
  }

  /**
   * 
   * @param {TimeLike} scrubTime 
   * @param {import('luxon').DurationLike} precision
   * 
   * @returns {TimelineDatum}
   */
  async getNearestDatum(scrubTime, precision) {
    throw new Error('getNearestDatum not implemented subclass of TimelineDataset');
  }
}